import { ReactNode } from "react";
import PageBodyWrapper from "../../components/PageBodyWrapper";
import { useParams, useLocation, useNavigate } from "react-router-dom";

interface TranslationWrapperProps {
  children: ReactNode;
}

function TranslationWrapper({ children }: TranslationWrapperProps) {
  const { languageCode } = useParams<{ languageCode: string }>();
  const location = useLocation();
  const navigate = useNavigate();

  const menuItems = [
    { label: "Collection", path: `/dashboard/translations/collections/${languageCode}` },
    { label: "Category", path: `/dashboard/translations/categories/${languageCode}` },
    { label: "Product", path: `/dashboard/translations/products/${languageCode}` },
    // { label: "Supplier", path: `/dashboard/translations/suppliers/${languageCode}` },
    { label: "Tags", path: `/dashboard/translations/tags/${languageCode}` },

    // Not for MVP
    // { label: "Tax", path: `/dashboard/translations/taxes/${languageCode}` },
    // { label: "Promocode", path: `/dashboard/translations/promocodes/${languageCode}` },
    // { label: "Shipping", path: `/dashboard/translations/shippings/${languageCode}` },
  ];

  const isActive = (path: string) => location.pathname === path;

  const handleNavigation = (path: string) => {
    navigate(path);
  };

  return (
    <PageBodyWrapper>

      <div className="text-center mt-2">
        <h4>Translation for {languageCode}</h4>
      </div>

      {/* Menu Bar */}
      <div className="flex gap-5 justify-center border-b border-[#EEEFF2] py-5 px-10 overflow-x-auto">
        {menuItems.map((item) => (
          <button
            key={item.path}
            onClick={() => handleNavigation(item.path)}
            className={`text-sm md:text-[16px] cursor-pointer ${isActive(item.path)
                ? "text-[#0CAF60] font-bold border-b-2 border-[#0CAF60] pb-2"
                : "text-gray-500 hover:text-[#0CAF60]"
              }`}
          >
            {item.label}
          </button>
        ))}
      </div>

      {/* Page Content */}
      {children}
    </PageBodyWrapper>
  );
}

export default TranslationWrapper;
